module.exports = __webpack_public_path__ + "img/globe-06.eeac6db4.svg";